// eslint-disable-next-line import/prefer-default-export
export const GET_SHIPPABLE_STORES_FOR_PICKUP = 'GET_SHIPPABLE_STORES_FOR_PICKUP';
